import { NavLink } from "react-router-dom";
import { useDeskStatus } from "@/lib/useLiveMarkets";

const TABS = [
  { to: "/p2p", label: "Offers", end: true },
  { to: "/p2p/orders", label: "My orders" },
  { to: "/p2p/my-ads", label: "My ads" },
  { to: "/p2p/payment-methods", label: "Payment methods" },
];

export default function P2PSubNav() {
  return (
    <div className="flex max-w-full gap-1 overflow-x-auto rounded-lg border border-border bg-surface-2 p-1" data-testid="p2p-subnav">
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.end}
          className={({ isActive }) =>
            `whitespace-nowrap rounded-md px-3 py-1.5 text-xs transition ${
              isActive ? "brand-gradient text-primary-foreground" : "text-muted-foreground hover:text-foreground"
            }`
          }
          data-testid={`p2p-subnav-${t.label.toLowerCase().replace(/\s+/g, "-")}`}
        >
          {t.label}
        </NavLink>
      ))}
    </div>
  );
}

/** Page header shared by every P2P screen: title on the left, section toggle on the right. */
export function P2PHeader({ title = "P2P trading", subtitle = "Offers refresh live as merchants fill or update them.", children }) {
  const desks = useDeskStatus();
  const paused = Object.entries(desks?.p2p || {}).filter(([, on]) => !on).map(([sym]) => sym);
  return (
    <>
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="text-3xl font-semibold" data-testid="p2p-page-title">
            {title}
          </h1>
          <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          {children}
          <P2PSubNav />
        </div>
      </div>
      {paused.length > 0 && (
        <p className="mt-4 rounded-lg border border-warning/40 bg-warning/10 px-4 py-2.5 text-sm text-warning" data-testid="p2p-paused">
          P2P trading for {paused.join(", ")} is paused right now. Open orders can still complete; new offers and orders are on hold.
        </p>
      )}
    </>
  );
}

/** Old PaisaCX page wrapper used by the P2P screens. */
export function P2PPage({ children }) {
  return <div className="page-fade mx-auto max-w-7xl px-4 py-10">{children}</div>;
}
